import Cookies from 'js-cookie';
import { parseCookie } from 'cookie';
import {
  TOKEN_KEY,
} from './constants';

const AUTH_CODE = [100005, 400200];

export function setToken(token: string) {
  Cookies.set(TOKEN_KEY, token, {
    expires: 30,
    path: '/',
    sameSite: 'Lax',
  });
}

export const clearToken = () => {
  Cookies.remove(TOKEN_KEY, {
    path: '/',
    sameSite: 'Lax',
  });
};

export const getToken = (cookieStr?: string) => {
  const source = cookieStr ?? (typeof document === 'undefined' ? '' : document.cookie);
  const cookieObject = parseCookie(source);

  return cookieObject[TOKEN_KEY] || '';
};

export const isLogin = (cookieStr?: string) => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    const source = cookieStr ?? (typeof document === 'undefined' ? '' : document.cookie);
    const cookieObject = parseCookie(source);

    return Boolean(cookieObject[TOKEN_KEY]);
  }
};

export const gotoLogin = async () => {
  const location = window.location;
  const from = `${location.pathname}${location.search}${location.hash}`;
  const base = `${window.location.protocol}//${window.location.host}`;
  const redirect = `${base}/callback?from=${encodeURIComponent(from)}`;
  const loginPath = `${import.meta.env.VITE_LOGIN_CALLBACK_URL}?transfer_redirect=${encodeURIComponent(redirect)}`;

  window.location.replace(loginPath);
};

export const isAuthCode = (code: number) => AUTH_CODE.includes(code);

export const isValidRedirect = (url: string): boolean => {
  return url.startsWith('/') && !url.startsWith('//');
};
